// extracted by mini-css-extract-plugin
module.exports = {"Orders":"Orders_Orders__1MLUZ"};